import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { ListGroup, ListGroupItem } from "reactstrap";
import { formatMoney } from "accounting";

const Item = ({ item, children }) => (
  <ListGroupItem className="service_items">
    <div className="row justify-content-between align-items-center">
      <div className="col-lg-6 col-sm-12">
        <div className="row">
          <div className="col-12 px-1">
            <h4 className="itemTitle">
              <b>{item.reason}</b>
            </h4>
          </div>
        </div>
        <div className="row">
          {item.type_service === "for_hours" && (
            <Fragment>
              <div className="col-auto px-1">
                <label>
                  Labor Time: <b>{item.labor_time} Hours</b> {item.taxable && "(Taxable)"}
                </label>
              </div>
              <div className="col-auto px-1">
                <label>
                  Part Price: <b>{formatMoney(item.part_price)}</b> {item.taxable && "(Taxable)"}
                </label>
              </div>
            </Fragment>
          )}
          {item.type_service === "flat_fee" && (
            <div className="col-auto px-1">
              <label>
                Price: <b>{formatMoney(item.flat_fee)}</b> {item.taxable && "(Taxable)"}
              </label>
            </div>
          )}
        </div>
      </div>
      {children && <div className="col-lg-6 col-xs-12 px-1">{children}</div>}
    </div>
  </ListGroupItem>
);

const ItemList = ({ items, children }) => {
  return (
    <ListGroup flush>
      {items.map((item, index) => (
        <Item key={item.id || index} item={item}>
          {typeof children === "function" && children({ item })}
        </Item>
      ))}
    </ListGroup>
  );
};

ItemList.propTypes = {
  items: PropTypes.array.isRequired
};

export default ItemList;
